import React from "react";
import PropTypes from "prop-types";

// display:contents keeps the wrapper out of the toolbar's flex layout
// while still catching clicks in the capture phase, so a control never
// opens (or promotes its screen) before the exit confirmation resolves
function WorkSessionExitGuard({ onIntercept, children }) {
  return (
    <span
      role="presentation"
      style={{ display: "contents" }}
      onClickCapture={onIntercept}
    >
      {children}
    </span>
  );
}

WorkSessionExitGuard.propTypes = {
  onIntercept: PropTypes.func.isRequired,
  children: PropTypes.node,
};

WorkSessionExitGuard.defaultProps = {
  children: null,
};

export default WorkSessionExitGuard;
